import React from 'react';
import MenuItems from '../../data/menu_items';
import {MusicCategoriesContainer, MusicSections, CategoryTitle} from './home.styles';

function Home(props){
    return (
        <MusicCategoriesContainer>
            {
                MenuItems.map( (menuItem) => {
                    return(
                    <MusicSections key={menuItem.id} onClick={()=>props.history.push(menuItem.link)} >
                        <CategoryTitle>{menuItem.name}</CategoryTitle>
                    </MusicSections>
                )})
            }
        </MusicCategoriesContainer>
    )
}
export default Home;

//https://api.genius.com/songs/${SongId}?&access_token=E-Rw-b6RTihJQB_PWP79wf30xJwVx4hw7r53VBMxRjS1p2s-A2VQb9qWX2DMe5O9

/* <MusicSections onClick={()=>props.history.push('/tracks')}>
<CategoryTitle>Songs</CategoryTitle>
</MusicSections>
<MusicSections>
<CategoryTitle>Billboard Top 50</CategoryTitle>
</MusicSections>
<MusicSections>
<CategoryTitle>India Top 50</CategoryTitle>
</MusicSections> */
// <StreamingVideoContainer>
// </StreamingVideoContainer>            
